"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var env_1 = require("./env");
function Link(props) {
    var as = props.as, className = props.className, children = props.children, _a = props.type, type = _a === void 0 ? 'blue' : _a, icon = props.icon, rootHtmlProps = props.rootHtmlProps, style = props.style, onClick = props.onClick, rest = tslib_1.__rest(props, ["as", "className", "children", "type", "icon", "rootHtmlProps", "style", "onClick"]);
    var prefix = ConfigProvider_1.usePrefix('link');
    var isBlueEnv = env_1.useEnv().isBlue;
    var classname = classnames_1.default(prefix, className, utils_1.concat(prefix, type), isBlueEnv && utils_1.concat(prefix, 'env', 'blue'), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var handleClick = react_1.useCallback(function (e) {
        var _a;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [rootHtmlProps, onClick]);
    var rootProps = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, rest), rootHtmlProps), { onClick: ((rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) || onClick) && handleClick, className: classname, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) });
    var suffix = type === 'black' ? react_1.default.createElement(react_1.default.Fragment, null,
        "\u00A0",
        react_1.default.createElement(icons_1.RightThinIcon, null)) : null;
    return (react_1.createElement(as !== null && as !== void 0 ? as : 'a', rootProps, (react_1.default.createElement(react_1.default.Fragment, null,
        icon && react_1.default.createElement("span", { className: utils_1.concat(prefix, 'icon') }, icon),
        children,
        suffix))));
}
exports.default = Link;
//# sourceMappingURL=index.js.map